import Vue from "vue";
import Router from "vue-router";
import Home from "@/pages/Home";
import DefaultView from "@/pages/publics/DefaultView";
import Public from "@/pages/publics/Public";
import PcibSnPublic from "@/pages/publics/PcibSnPublic";
import oemLogin from "@/pages/mirrors/oems/LoginOem";
// import pcibSnLogin from "@/pages/mirrors/pcibs/LoginSnPcib";
import LoginFirstStepPcib from "@/pages/mirrors/pcibs/LoginFirstStepPcib";

import pcibLogin from "@/pages/mirrors/auths/PcibLogin";
import pcibForgetPwd from "@/pages/mirrors/auths/PcibForgetPwd";
import pcibＭain from "@/pages/mirrors/auths/PcibMain";
import SerialDetails from "@/pages/mirrors/auths/SerialDetails";
import MyAuth from "@/pages/mirrors/auths/MyAuth";
import importFile from "@/pages/mirrors/auths/ImportFile";
import account from "@/pages/mirrors/auths/Account";
import Contacts from "@/pages/mirrors/auths/Contacts";
import ContactDetails from "@/pages/mirrors/auths/ContactDetails";
import NewPwd from "@/pages/mirrors/auths/NewPwd";
import ChangeSuccess from "@/pages/mirrors/auths/ChangeSuccess";

import PcibOrderLogin from "@/pages/mirrors/auths/PcibOrderLogin";
import PcibOrderForgetPwd from "@/pages/mirrors/auths/PcibOrderForgetPwd";
import PcibOrderＭain from "@/pages/mirrors/auths/PcibOrderMain";
import PcibOrderSerialDetails from "@/pages/mirrors/auths/PcibOrderSerialDetails";
import PcibOrderMyAuth from "@/pages/mirrors/auths/PcibOrderMyAuth";
import PcibOrderImportFile from "@/pages/mirrors/auths/PcibOrderImportFile";
import PcibOrderAccount from "@/pages/mirrors/auths/PcibOrderAccount";
import PcibOrderContacts from "@/pages/mirrors/auths/PcibOrderContacts";
import PcibOrderContactDetails from "@/pages/mirrors/auths/PcibOrderContactDetails";
import PcibOrderNewPwd from "@/pages/mirrors/auths/PcibOrderNewPwd";
import PcibOrderChangeSuccess from "@/pages/mirrors/auths/PcibOrderChangeSuccess";
import PcibOrderHelp from "@/pages/mirrors/auths/PcibOrderHelp";


import ErrorView from "@/pages/publics/Error";
import CmopLogin from "@/pages/cmop/CmopLogin";
import CmopDetail from "@/pages/cmop/CmopDetail";

Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [{
        path: "/",
        name: "home",
        component: Home,
        children: [{
                path: "",
                component: DefaultView,
                name: "default"
            },
            {
                path: "/error",
                name: "error",
                component: ErrorView
            },
            {
                path: "/cmop",
                redirect: "/cmop/login"
            },
            {
                path: "/cmop/login",
                name: "cmopLogin",
                component: CmopLogin
            },
            {
                path: "/cmop/details",
                name: "cmopDetail",
                component: CmopDetail
            },
            {
                path: "/pcib",
                redirect: "/pcibOrder/login"
            },
            {
                path: "/pcib/login",
                // name: "pcibLogin",
                // component: pcibLogin
                redirect: "/pcibOrder/login"
            },
            {
                path: "/pcibOrder",
                redirect: "/pcibOrder/login"
            },
            // {
            //     path: "/pcibOrder/login",
            //     name: "pcibOrderLogin",
            //     component: PcibOrderLogin
            // },

            {
              path: "/pcibOrder/login",
              name: "loginFirstStepPcib",
              component: LoginFirstStepPcib
            },
            {
                path: "/pcibOrder/orderLogin",
                name: "pcibOrderLogin",
                component: PcibOrderLogin
            },

            {
                path: "/pcibOrder/forget",
                name: "pcibOrderForget",
                component: PcibOrderForgetPwd
            },
            {
                path: "/pcib/forget",
                // name: "pcibForget",
                // component: pcibForgetPwd
                redirect: "/pcibOrder/forget"
            },
            {
                path: "/pcib/home",
                name: "pcibHome",
                // component: pcibOrderＭain,
                redirect: {
                    name: "pcibOrderList"
                },
                children: [{
                        path: "/pcib/home/list",
                        name: "pcibList",
                        // component: MyAuth,
                        // meta: {
                        //     cName: "订单列表"
                        // },
                        redirect: {
                            name: "pcibOrderList"
                        }
                    },
                    {
                        path: "/pcib/home/:order_id",
                        // name: "serialDetails",
                        // component: SerialDetails,
                        // meta: {
                        //     cName: "订单详情"
                        // }
                        redirect: {
                            name: "pcibOrderSerialDetails"
                        }
                    },
                    {
                        path: "/pcib/contacts",
                        // name: "contacts",
                        // component: Contacts,
                        // meta: {
                        //     cName: "联系人管理"
                        // }
                        redirect: {
                            name: "pcibOrderContacts"
                        }
                    },
                    {
                        path: "/pcib/contactDetails",
                        // name: "contactDetails",
                        // component: ContactDetails,
                        // meta: {
                        //     cName: "联系人详情"
                        // }
                        redirect: {
                            name: "pcibOrderContactDetails"
                        }
                    },
                    {
                        path: "/pcib/account",
                        // name: "account",
                        // component: account,
                        // meta: {
                        //     cName: "密码管理"
                        // }
                        redirect: {
                            name: "pcibOrderAccount"
                        }
                    }
                ]
            },
            {
                path: "/pcibOrder/home",
                name: "pcibOrderHome",
                component: PcibOrderＭain,
                redirect: {
                    name: "pcibOrderList"
                },
                children: [{
                        path: "/pcibOrder/home/list",
                        name: "pcibOrderList",
                        component: PcibOrderMyAuth,
                        meta: {
                            cName: "订单列表"
                        }
                    },
                    {
                        path: "/pcibOrder/home/:order_id",
                        name: "pcibOrderSerialDetails",
                        component: PcibOrderSerialDetails,
                        meta: {
                            cName: "订单详情"
                        }
                    },
                    {
                        path: "/pcibOrder/contacts",
                        name: "pcibOrderContacts",
                        component: PcibOrderContacts,
                        meta: {
                            cName: "订单联系人管理"
                        }
                    },
                    {
                        path: "/pcibOrder/contactDetails",
                        name: "pcibOrderContactDetails",
                        component: PcibOrderContactDetails,
                        meta: {
                            cName: "联系人详情"
                        }
                    },
                    {
                        path: "/pcibOrder/account",
                        name: "pcibOrderAccount",
                        component: PcibOrderAccount,
                        meta: {
                            cName: "修改本人信息"
                        }
                    }
                ]
            },
            {
                path: "/pcib/import",
                // name: "pcibImport",
                // component: importFile
                redirect: "/pcibOrder/import"
            },
            {
                path: "/pcib/new_pwd",
                // name: "newPwd",
                // component: NewPwd
                redirect: "/pcibOrder/new_pwd"
            },
            {
                path: "/pcib/success",
                // name: "success",
                // component: ChangeSuccess
                redirect: "/pcibOrder/success"
            },
            {
                path: "/pcibOrder/import",
                name: "pcibOrderImport",
                component: PcibOrderImportFile
            },
            {
                path: "/pcibOrder/new_pwd",
                name: "pcibOrderNewPwd",
                component: PcibOrderNewPwd
            },
            {
                path: "/pcibOrder/success",
                name: "pcibOrderSuccess",
                component: PcibOrderChangeSuccess
            },
            {
                path: "/pcibOrder/help",
                name: "pcibOrderHelp",
                component: PcibOrderHelp
            },
            {
                path: "/oem/login",
                name: "login",
                component: oemLogin
            },
            {
                path: "/oem/public/:id",
                name: "oemPublic",
                component: Public
            },
            // {
            //   path: "/pcib/snLogin",
            //   name: "pcibSnLogin",
            //   component: pcibSnLogin
            // },
            {
              path: "/pcib/PcibSnPublic/:id",
              name: "pcibSnPublic",
              component: PcibSnPublic
            },
            {
                path: "/tools",
                redirect: "/public/tools/1"
            },
            {
                path: "/public/:id/:classify?",
                name: "public",
                component: Public
            },
            {
                path: "/oem",
                redirect: "/oem/public/oem"
            },
            {
                path: "/search",
                redirect: "/public/search"
            },
            {
                path: "*",
                redirect: "/error"
            }
        ]
    }]
});



// WEBPACK FOOTER //
// ./src/router/index.js